<div class="container">
  <div class="row header-row">
    <div
      class="col-12 col-md-4 text-center text-md-start header-logo-col"
      [class.col-md-6]="!(showSearch$ | async) || isSecuritySetupRoute"
    >
      <div class="header-logo-row">

        <!-- Mobile: search open — inline search bar + close button -->
        <ng-container *ngIf="mobileSearchOpen">
          <div class="mobile-search-bar d-md-none">
            <div class="search-panel search-panel-lg mobile-search-inline-panel" [class.search-page-mode]="isOnSearchPage">
              <div class="hovering-search-icon">
                <fa-icon [icon]="faMagnifyingGlass" transform="left-2"></fa-icon>
              </div>
              <input type="text" class="form-control form-control-lg form-control-search"
                placeholder="Search..." autocomplete="off" autocorrect="off" autocapitalize="off"
                spellcheck="false" [formControl]="queryField" enterkeyhint="search" aria-label="Search"
                [attr.aria-expanded]="searchResultsOpen && !isOnSearchPage"
                (focus)="onSearchInputFocus()" (blur)="closeSearchResults()"
                (keydown)="onSearchInputKeydown($event)" (keydown.enter)="navigateToSearch()" #mobileSearchBox>
              <button type="button" class="clear-button" (mousedown)="$event.preventDefault()" (click)="clear()" *ngIf="hasQuery" aria-label="Clear search">
                <fa-icon [icon]="faTimes"></fa-icon>
              </button>
            </div>

          <button
            type="button"
            class="btn btn-link mobile-user-button is-close d-md-none"
            (click)="closeMobileSearch()"
            aria-label="Close search"
          >
            <fa-icon [icon]="faTimes"></fa-icon>
          </button>
          </div>
        </ng-container>

        <!-- Logo + action buttons (hidden on mobile when search is open) -->
        <ng-container *ngIf="!mobileSearchOpen">
          <div class="header-logo-stack">
            <ng-container *ngIf="(headerLogo$ | async) as headerLogo; else standardLogo">
              <a [routerLink]="headerLogoLink$ | async" class="logo">
                <img [src]="headerLogo" alt="Logo" class="header-logo-image header-logo-image-custom">
              </a>
              <a routerLink="/" class="powered-by-link" aria-label="Go to TRACit home">
                <span class="powered-by-text">
                  <span>powered by</span>
                  <img src="/assets/logo-full.svg" alt="TRACit" class="powered-by-logo">
                </span>
              </a>
            </ng-container>
            <ng-template #standardLogo>
              <a [routerLink]="headerLogoLink$ | async" class="logo">
                <img src="/assets/logo-full.svg" alt="TRACit" class="header-logo-image">
              </a>
            </ng-template>
          </div>

          <ng-container *ngIf="(showSearch$ | async) && !isSecuritySetupRoute; else noSearchMobileActions">
            <!-- Mobile: search icon circle + user avatar, shown only when search is enabled -->
            <div class="header-mobile-actions d-md-none" *ngIf="user">
              <button
                type="button"
                class="btn btn-link mobile-search-trigger"
                (click)="openMobileSearch()"
                aria-label="Open search"
              >
                <fa-icon [icon]="faMagnifyingGlass"></fa-icon>
              </button>

              <button
                type="button"
                class="btn btn-link mobile-user-button"
                [class.is-close]="mobileUserMenuOpen"
                (click)="toggleMobileUserMenu()"
                [attr.aria-expanded]="mobileUserMenuOpen"
                [attr.aria-label]="mobileUserMenuOpen ? 'Close user menu' : 'Open user menu'"
              >
                <fa-icon [icon]="faTimes" *ngIf="mobileUserMenuOpen; else mobileWithSearchUserAvatar"></fa-icon>
                <ng-template #mobileWithSearchUserAvatar>
                  <span class="header-user-avatar-wrap">
                    <span class="header-user-avatar header-user-avatar-sm">
                      <ng-container *ngIf="user.photoUrl; else mobileWithSearchAvatarFallback">
                        <img [src]="user.photoUrl" [alt]="(user.firstName || '') + ' ' + (user.lastName || '')" class="header-user-avatar-image">
                      </ng-container>
                      <ng-template #mobileWithSearchAvatarFallback>
                        <span class="header-user-avatar-fallback">{{ getUserInitials(user) }}</span>
                      </ng-template>
                    </span>
                    <span class="header-user-attention-badge" *ngIf="complianceNeedsAttention" aria-hidden="true">
                      <fa-icon [icon]="faTriangleExclamation"></fa-icon>
                    </span>
                  </span>
                </ng-template>
              </button>
            </div>
          </ng-container>

          <ng-template #noSearchMobileActions>
          <!-- Mobile: user button only, with open/close state, when search is not enabled -->
          <button
            type="button"
            class="btn btn-link mobile-user-button d-md-none"
            [class.is-close]="mobileUserMenuOpen"
            *ngIf="user"
            (click)="toggleMobileUserMenu()"
            [attr.aria-expanded]="mobileUserMenuOpen"
            [attr.aria-label]="mobileUserMenuOpen ? 'Close user menu' : 'Open user menu'"
          >
            <fa-icon [icon]="faTimes" *ngIf="mobileUserMenuOpen; else mobileUserButtonAvatar"></fa-icon>
            <ng-template #mobileUserButtonAvatar>
              <span class="header-user-avatar-wrap">
              <span class="header-user-avatar header-user-avatar-sm">
                <ng-container *ngIf="user.photoUrl; else mobileHeaderAvatarFallback">
                  <img [src]="user.photoUrl" [alt]="(user.firstName || '') + ' ' + (user.lastName || '')" class="header-user-avatar-image">
                </ng-container>
                <ng-template #mobileHeaderAvatarFallback>
                  <span class="header-user-avatar-fallback">{{ getUserInitials(user) }}</span>
                </ng-template>
              </span>
              <span class="header-user-attention-badge" *ngIf="complianceNeedsAttention" aria-hidden="true">
                <fa-icon [icon]="faTriangleExclamation"></fa-icon>
              </span>
              </span>
            </ng-template>
          </button>
        </ng-template>
        </ng-container><!-- end !mobileSearchOpen -->

      </div>

      <!-- Mobile search results: outside the flex row, positioned absolute relative to :host -->
      <div class="mobile-inline-search-results d-md-none" *ngIf="mobileSearchOpen">
        <ng-container *ngTemplateOutlet="searchResultsTemplate"></ng-container>
      </div>
    </div>

    <!-- Desktop-only inline search bar -->
    <div class="col-md-4 order-2 order-md-2 header-search-col d-none d-md-block" *ngIf="(showSearch$ | async) && !isSecuritySetupRoute">
      <div class="d-flex justify-content-center w-100">
        <div class="header-search-row">
          <div
            id="searchPanelBox"
            class="search-panel search-panel-lg header-search-panel"
            [class.search-page-mode]="isOnSearchPage"
            #searchPanelBox
          >
            <div class="hovering-search-icon">
              <fa-icon [icon]="faMagnifyingGlass" transform="left-2"></fa-icon>
            </div>
            <input type="text" class="form-control form-control-lg form-control-search"
              placeholder="Search..." autocomplete="off" autocorrect="off" autocapitalize="off"
              spellcheck="false" [formControl]="queryField" enterkeyhint="search" aria-label="Search"
              [attr.aria-expanded]="searchResultsOpen && !isOnSearchPage"
              (focus)="onSearchInputFocus(true)" (blur)="closeSearchResults()"
              (keydown)="onSearchInputKeydown($event)" (keydown.enter)="navigateToSearch()" #searchBox>
            <button type="button" class="clear-button" (mousedown)="$event.preventDefault()" (click)="clear()" *ngIf="hasQuery" aria-label="Clear search">
              <fa-icon [icon]="faTimes"></fa-icon>
            </button>

            <ng-container *ngTemplateOutlet="searchResultsTemplate"></ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-md-4 text-center text-md-end order-3 order-md-3 header-user-col d-none d-md-block"
      [class.col-md-6]="!(showSearch$ | async) || isSecuritySetupRoute">
      <ng-container *ngIf="!user">
        <div class="pt-1 user-info" aria-hidden="true">
          <div class="header-user-skeleton">
            <span class="header-user-skeleton-avatar"></span>
            <span class="header-user-skeleton-copy">
              <span class="header-user-skeleton-line header-user-skeleton-line-name"></span>
              <span class="header-user-skeleton-line header-user-skeleton-line-email"></span>
            </span>
            <span class="header-user-skeleton-caret"></span>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="user">
        <div class="pt-1 user-info">
          <div ngbDropdown #accountMenuDropdown="ngbDropdown" class="account-menu" placement="bottom-end">
            <button type="button" class="btn account-chip" ngbDropdownToggle aria-label="Open account menu">
              <span class="header-user-avatar-wrap">
                <span class="header-user-avatar">
                  <ng-container *ngIf="user.photoUrl; else headerAvatarFallback">
                    <img [src]="user.photoUrl" [alt]="(user.firstName || '') + ' ' + (user.lastName || '')" class="header-user-avatar-image">
                  </ng-container>
                  <ng-template #headerAvatarFallback>
                    <span class="header-user-avatar-fallback">{{ getUserInitials(user) }}</span>
                  </ng-template>
                </span>
                <span class="header-user-attention-badge" *ngIf="complianceNeedsAttention" aria-hidden="true">
                  <fa-icon [icon]="faTriangleExclamation"></fa-icon>
                </span>
              </span>
              <span class="account-chip-copy">
                <span class="account-chip-name">{{ user | displayName }}</span>
                <span class="account-chip-email">{{ user.email }}</span>
              </span>
              <fa-icon [icon]="faChevronDown" class="account-chip-caret"></fa-icon>
            </button>

            <div ngbDropdownMenu class="account-menu-panel" [class.account-menu-panel-compact]="isSecuritySetupRoute">
              <ng-container *ngIf="!isSecuritySetupRoute">
                <div class="account-menu-summary">
                  <div class="account-menu-summary-copy">
                    <div class="account-menu-summary-title">{{ memberSinceLabel }}</div>
                    <div class="account-menu-summary-subtitle">{{ memberSinceSubtitle }}</div>
                  </div>
                  <div
                    class="account-menu-summary-art"
                    [class.is-attention]="complianceNeedsAttention"
                    [class.is-compliant]="!complianceNeedsAttention"
                    aria-hidden="true"
                  >
                    <div class="account-menu-compliance-card">
                      <div class="account-menu-compliance-card-shell">
                        <fa-icon [icon]="faIdCard" class="account-menu-compliance-card-icon"></fa-icon>
                        <span class="account-menu-compliance-line account-menu-compliance-line-a"></span>
                        <span class="account-menu-compliance-line account-menu-compliance-line-b"></span>
                        <span class="account-menu-compliance-line account-menu-compliance-line-c"></span>
                        <span class="account-menu-compliance-scan"></span>
                      </div>
                      <span class="account-menu-compliance-badge">
                        <fa-icon [icon]="complianceNeedsAttention ? faTriangleExclamation : faBadgeCheck"></fa-icon>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="account-menu-divider" aria-hidden="true"></div>

                <button type="button" ngbDropdownItem class="account-menu-item" *ngIf="user.id" (click)="openEditProfileModal(accountMenuDropdown)">
                  <span class="account-menu-item-icon">
                    <fa-icon [icon]="faUserGear"></fa-icon>
                  </span>
                  <span class="account-menu-item-label">Edit Profile</span>
                </button>

                <a ngbDropdownItem class="account-menu-item" [class.is-active]="isMyDashboardActive()" *ngIf="user.id" [routerLink]="['/a', user.id]">
                  <span class="account-menu-item-icon">
                    <fa-icon [icon]="faMenuUser"></fa-icon>
                  </span>
                  <span class="account-menu-item-label">Dashboard</span>
                </a>

                <a ngbDropdownItem class="account-menu-item" [class.is-active]="isMyDocumentsActive()" *ngIf="user.id" [routerLink]="['/a', user.id, 'documents']">
                  <span class="account-menu-item-icon">
                    <fa-icon [icon]="faMenuDocuments"></fa-icon>
                  </span>
                  <span class="account-menu-item-label">Documents</span>
                </a>

                <a ngbDropdownItem class="account-menu-item" [class.is-active]="isAccountSettingsActive()" *ngIf="user.id" [routerLink]="['/a', user.id, 'settings']">
                  <span class="account-menu-item-icon">
                    <fa-icon [icon]="faGear"></fa-icon>
                  </span>
                  <span class="account-menu-item-label">Account Settings</span>
                </a>

                <ng-container *ngIf="{ dark: (isDarkMode$ | async), preference: (themePreference$ | async) } as theme">
                  <div class="account-menu-theme-control" role="group" aria-label="Appearance">
                    <div class="account-menu-theme-header">
                      <span class="account-menu-item-icon account-menu-theme-icon">
                        <fa-icon [icon]="theme.dark ? faMoon : faSun"></fa-icon>
                      </span>
                      <span class="account-menu-theme-copy">
                        <span class="account-menu-item-label">Appearance</span>
                        <span class="account-menu-theme-subtitle">{{ getThemePreferenceSummary(theme.preference, theme.dark) }}</span>
                      </span>
                    </div>
                    <div class="account-menu-theme-options">
                      <button
                        *ngFor="let option of themeOptions"
                        type="button"
                        class="account-menu-theme-option"
                        [class.is-active]="theme.preference === option.value"
                        [attr.aria-pressed]="theme.preference === option.value"
                        (click)="setThemePreference(option.value)"
                      >
                        {{ option.label }}
                      </button>
                    </div>
                  </div>
                </ng-container>

                <div class="account-menu-divider" *ngIf="'admin' | role" aria-hidden="true"></div>

                <a ngbDropdownItem class="account-menu-item" [class.is-active]="isAdminDashboardActive()" *ngIf="'admin' | role" routerLink="/admin">
                  <span class="account-menu-item-icon">
                    <fa-icon [icon]="faMenuBuilding"></fa-icon>
                  </span>
                  <span class="account-menu-item-label">Administration</span>
                </a>

                <div class="account-menu-divider" aria-hidden="true"></div>
              </ng-container>

              <button type="button" ngbDropdownItem class="account-menu-item account-menu-item-danger" routerLink="/signout">
                <span class="account-menu-item-icon">
                  <fa-icon [icon]="faRightFromBracket"></fa-icon>
                </span>
                <span class="account-menu-item-label">Sign Out</span>
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<!-- Shared search results template (used by desktop inline panel and mobile fullscreen panel) -->
<ng-template #searchResultsTemplate>
  <ng-container *ngIf="(userHistory$ | async) as userHistory">
    <div class="search-results-popup" [class.is-open]="!hasQuery && searchResultsOpen && (userHistoryCount$ | async) && !isOnSearchPage"
      (focusin)="cancelSearchResultsClose()" (focusout)="closeSearchResults()"
      [style.width.px]="searchBoxWidth">
      <div class="search-popup-header d-md-none">
        <button type="button" class="btn btn-link mobile-search-close p-0" (click)="closeSearchPopover()" aria-label="Close search">
          <fa-icon [icon]="faTimes"></fa-icon>
        </button>
      </div>

      <div class="results results-short">
        <div class="result-group-title">
          <fa-icon [icon]="faHistory"></fa-icon>
          <span class="ms-2">Recently Viewed</span>
        </div>

        <div class="result-group">
          <ng-container *ngFor="let historyItem of userHistory">
            <a class="result-item result-item-primary search-agent-result"
              [routerLink]="resultLink(historyItem.itemType === 'user' ? 'agent' : 'group', historyItem.itemId)"
              (focus)="onSearchResultFocus()" (keydown)="onSearchResultKeydown($event)" (click)="onSearchResultClick()">
              <div class="search-agent-avatar">
                <span class="search-agent-avatar-fallback">
                  <ng-container *ngIf="historyItem.itemType === 'user'">{{ getHistoryItemInitials(historyItem.itemName) }}</ng-container>
                  <fa-icon [icon]="faBuilding" *ngIf="historyItem.itemType === 'group'"></fa-icon>
                </span>
              </div>
              <div class="search-agent-main">
                <div class="search-agent-name text-truncate" [title]="historyItem.itemName">
                  <span class="result-item-primary-text" [innerText]="historyItem.itemName"></span>
                </div>
                <div class="search-agent-office">
                  {{ historyItem.accessedAt | firestoreDate | safeTimeago }}
                </div>
              </div>
            </a>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="search-results-popup" [class.is-open]="hasQuery && searchResultsOpen && !isOnSearchPage"
    (focusin)="cancelSearchResultsClose()" (focusout)="closeSearchResults()" [style.width.px]="searchBoxWidth">
    <div class="search-popup-header d-md-none">
      <button type="button" class="btn btn-link mobile-search-close p-0" (click)="closeSearchPopover()" aria-label="Close search">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </div>

    <ng-container *ngIf="(searchResults$ | async) as searchResults">
      <ng-container *ngIf="searchResults">
        <ng-container *ngIf="!searchResults.totalCount">
          <div class="p-3 text-center text-muted">
            <strong class="text-danger">
              No results found
            </strong>
          </div>
        </ng-container>

        <div class="results results-short">
          <ng-container *ngFor="let category of searchResults.categoryOrder">
            <ng-container *ngIf="category === 'agents' && searchResults.agentCount > 0">
              <div class="result-group-title">
                <fa-icon [icon]="faUser"></fa-icon>
                <span class="ms-2">Agents</span>
              </div>

              <div class="result-group">
                <ng-container *ngFor="let member of searchResults.agents">
                  <a class="result-item result-item-primary search-agent-result" [routerLink]="resultLink('agent', member.objectID)"
                    (focus)="onSearchResultFocus()" (keydown)="onSearchResultKeydown($event)" (click)="onSearchResultClick()">
                    <div class="search-agent-avatar">
                      <ng-container *ngIf="member.photoUrl; else searchAgentAvatarFallback">
                        <img [ngSrc]="member.photoUrl" [alt]="member.name || 'Agent'" class="search-agent-avatar-image" width="36" height="36">
                      </ng-container>
                      <ng-template #searchAgentAvatarFallback>
                        <span class="search-agent-avatar-fallback">{{ getSearchResultInitials(member) }}</span>
                      </ng-template>
                    </div>

                    <div class="search-agent-main">
                      <div class="search-agent-heading">
                        <div class="search-agent-name text-truncate" [title]="member.name">
                          <span class="result-item-primary-text" [innerText]="member.name"></span>
                        </div>
                        <div class="search-agent-office text-truncate" *ngIf="member.group?.name" [title]="member.group?.name">
                          {{ member.group?.name }}
                        </div>
                      </div>

                      <div class="search-agent-licences" *ngIf="getSearchResultLicences(member) as licences">
                        <ng-container *ngIf="licences.length; else noSearchAgentLicences">
                          <span class="search-agent-licence" *ngFor="let licence of licences; trackBy: trackBySearchResultLicence">
                            <span class="search-agent-licence-region" *ngIf="licence.region">{{ licence.region }}</span>
                            <span class="search-agent-licence-number">{{ licence.licenceNumber || 'Licence' }}</span>
                          </span>
                        </ng-container>
                        <ng-template #noSearchAgentLicences>
                          <span class="search-agent-licence search-agent-licence-muted">No licence on record</span>
                        </ng-template>
                      </div>
                    </div>
                  </a>
                </ng-container>
              </div>
            </ng-container>

            <ng-container *ngIf="category === 'offices' && searchResults.officeCount > 0">
              <div class="result-group-title">
                <fa-icon [icon]="faBuilding"></fa-icon>
                <span class="ms-2">Offices</span>
              </div>

              <div class="result-group">
                <div class="result-item result-item-header">
                  <div class="row">
                    <div class="col-12">
                      Name
                    </div>
                  </div>
                </div>
                <ng-container *ngFor="let office of searchResults.offices">
                  <a class="result-item result-item-primary" [routerLink]="resultLink('group', office.objectID)"
                    (focus)="onSearchResultFocus()" (keydown)="onSearchResultKeydown($event)" (click)="onSearchResultClick()">
                    <div class="row">
                      <div class="col-12 text-truncate" [title]="office.name">
                        <span class="result-item-primary-text" [innerText]="office.name"></span>
                      </div>
                    </div>
                  </a>
                </ng-container>
              </div>
            </ng-container>

            <ng-container *ngIf="category === 'franchisors' && searchResults.franchisorCount > 0">
              <div class="result-group-title">
                <fa-icon [icon]="faBuilding"></fa-icon>
                <span class="ms-2">Groups</span>
              </div>

              <div class="result-group">
                <div class="result-item result-item-header">
                  <div class="row">
                    <div class="col-12">
                      Name
                    </div>
                  </div>
                </div>
                <ng-container *ngFor="let franchisor of searchResults.franchisors">
                  <a class="result-item result-item-primary" [routerLink]="resultLink('group', franchisor.objectID)"
                    (focus)="onSearchResultFocus()" (keydown)="onSearchResultKeydown($event)" (click)="onSearchResultClick()">
                    <div class="row">
                      <div class="col-12 text-truncate" [title]="franchisor.name">
                        <span class="result-item-primary-text" [innerText]="franchisor.name"></span>
                      </div>
                    </div>
                  </a>
                </ng-container>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>

    <div class="search-popup-footer" *ngIf="hasQuery && !isOnSearchPage">
      <a
        class="see-all-results-link"
        [routerLink]="['/search']"
        [queryParams]="{ q: queryField.value }"
        (mousedown)="$event.preventDefault()"
        (focus)="onSearchResultFocus()"
        (keydown)="onSearchResultKeydown($event)"
        (click)="closeSearchPopover()"
      >
        <fa-icon [icon]="faMagnifyingGlass" class="me-1"></fa-icon>
        See all results for &ldquo;{{ queryField.value }}&rdquo;
        <fa-icon [icon]="faArrowRight" class="ms-1"></fa-icon>
      </a>
    </div>
  </div>
</ng-template>

<div
  class="mobile-search-overlay"
  [class.is-open]="searchResultsOpen && !isOnSearchPage && !mobileSearchOpen"
  (click)="closeSearchPopover()"
></div>

<div class="mobile-user-overlay d-md-none" [class.is-open]="mobileUserMenuOpen" (click)="closeMobileUserMenu()">
  <div class="mobile-user-panel" [class.is-open]="mobileUserMenuOpen" (click)="$event.stopPropagation()">
    <ng-container *ngIf="user">
      <div class="mobile-user-summary">
        <span class="header-user-avatar">
          <ng-container *ngIf="user.photoUrl; else mobilePanelAvatarFallback">
            <img [src]="user.photoUrl" [alt]="(user.firstName || '') + ' ' + (user.lastName || '')" class="header-user-avatar-image">
          </ng-container>
          <ng-template #mobilePanelAvatarFallback>
            <span class="header-user-avatar-fallback">{{ getUserInitials(user) }}</span>
          </ng-template>
        </span>
        <div class="mobile-user-summary-copy">
          <div class="mobile-user-name">
            {{ user | displayName }}
          </div>
          <div class="mobile-user-email">{{ user.email }}</div>
        </div>
      </div>

      <ng-container *ngIf="!isSecuritySetupRoute">
        <div class="account-menu-summary">
          <div class="account-menu-summary-copy">
            <div class="account-menu-summary-title">{{ memberSinceLabel }}</div>
            <div class="account-menu-summary-subtitle">{{ memberSinceSubtitle }}</div>
          </div>
          <div
            class="account-menu-summary-art"
            [class.is-attention]="complianceNeedsAttention"
            [class.is-compliant]="!complianceNeedsAttention"
            aria-hidden="true"
          >
            <div class="account-menu-compliance-card">
              <div class="account-menu-compliance-card-shell">
                <fa-icon [icon]="faIdCard" class="account-menu-compliance-card-icon"></fa-icon>
                <span class="account-menu-compliance-line account-menu-compliance-line-a"></span>
                <span class="account-menu-compliance-line account-menu-compliance-line-b"></span>
                <span class="account-menu-compliance-line account-menu-compliance-line-c"></span>
                <span class="account-menu-compliance-scan"></span>
              </div>
              <span class="account-menu-compliance-badge">
                <fa-icon [icon]="complianceNeedsAttention ? faTriangleExclamation : faBadgeCheck"></fa-icon>
              </span>
            </div>
          </div>
        </div>

        <div class="mobile-user-actions">
          <button type="button" class="btn mobile-user-action" *ngIf="user.id" (click)="openEditProfileModal(undefined, true)">
            <span class="account-menu-item-icon">
              <fa-icon [icon]="faUserGear"></fa-icon>
            </span>
            <span>Edit Profile</span>
          </button>

          <a class="btn mobile-user-action" [class.is-active]="isMyDashboardActive()" *ngIf="user.id" [routerLink]="['/a', user.id]" (click)="closeMobileUserMenu()">
            <span class="account-menu-item-icon">
              <fa-icon [icon]="faMenuUser"></fa-icon>
            </span>
            <span>Dashboard</span>
          </a>

          <a class="btn mobile-user-action" [class.is-active]="isMyDocumentsActive()" *ngIf="user.id" [routerLink]="['/a', user.id, 'documents']" (click)="closeMobileUserMenu()">
            <span class="account-menu-item-icon">
              <fa-icon [icon]="faMenuDocuments"></fa-icon>
            </span>
            <span>Documents</span>
          </a>

          <a class="btn mobile-user-action" [class.is-active]="isAccountSettingsActive()" *ngIf="user.id" [routerLink]="['/a', user.id, 'settings']" (click)="closeMobileUserMenu()">
            <span class="account-menu-item-icon">
              <fa-icon [icon]="faGear"></fa-icon>
            </span>
            <span>Account Settings</span>
          </a>

          <ng-container *ngIf="{ dark: (isDarkMode$ | async), preference: (themePreference$ | async) } as theme">
            <div class="mobile-user-action account-menu-theme-control" role="group" aria-label="Appearance">
              <div class="account-menu-theme-header">
                <span class="account-menu-item-icon account-menu-theme-icon">
                  <fa-icon [icon]="theme.dark ? faMoon : faSun"></fa-icon>
                </span>
                <span class="account-menu-theme-copy">
                  <span class="account-menu-item-label">Appearance</span>
                  <span class="account-menu-theme-subtitle">{{ getThemePreferenceSummary(theme.preference, theme.dark) }}</span>
                </span>
              </div>
              <div class="account-menu-theme-options">
                <button
                  *ngFor="let option of themeOptions"
                  type="button"
                  class="account-menu-theme-option"
                  [class.is-active]="theme.preference === option.value"
                  [attr.aria-pressed]="theme.preference === option.value"
                  (click)="setThemePreference(option.value)"
                >
                  {{ option.label }}
                </button>
              </div>
            </div>
          </ng-container>

          <div class="mobile-user-divider" *ngIf="'admin' | role" aria-hidden="true"></div>

          <ng-container *ngIf="'admin' | role">
            <a class="btn mobile-user-action" [class.is-active]="isAdminDashboardActive()" routerLink="/admin" (click)="closeMobileUserMenu()">
              <span class="account-menu-item-icon">
                <fa-icon [icon]="faMenuBuilding"></fa-icon>
              </span>
              <span>Administration</span>
            </a>
          </ng-container>

          <div class="mobile-user-divider" aria-hidden="true"></div>
        </div>
      </ng-container>

      <div class="mobile-user-actions">
        <button type="button" class="btn mobile-user-action mobile-user-action-danger" routerLink="/signout" (click)="closeMobileUserMenu()">
          <span class="account-menu-item-icon">
            <fa-icon [icon]="faRightFromBracket"></fa-icon>
          </span>
          <span>Sign Out</span>
        </button>
      </div>
    </ng-container>
  </div>
</div>
